import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#5599FF",
                background: "#F5F5F5",
                shades:"#e6f7ff"
            },
            dark: {
                primary: colors.blue.lighten3,
            },
        },
    },
});
